import { SendOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form, message, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { startTenantTurboModeMutation } from '../../constants';

const { Text } = Typography;

function SendEnableTurboModeCommand({ joonDevice }) {
  const [form] = Form.useForm();
  const [error, setError] = useState();

  const [startTurboMode, { loading }] = useMutation(
    startTenantTurboModeMutation,
  );

  const handleEnableTurboMode = useCallback(async () => {
    setError(undefined);
    try {
      await startTurboMode({
        variables: {
          deviceId: joonDevice._id,
        },
      });
      message.success('Turbo Mode enabled successfully!');
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  }, [joonDevice, startTurboMode]);

  return (
    <Card
      title="Enable Turbo Mode"
      className="config-cmd"
      style={{ marginBottom: 16 }}
    >
      <Form
        onFinish={handleEnableTurboMode}
        layout="vertical"
        style={{ maxWidth: 600 }}
        form={form}
      >
        <Form.Item noStyle shouldUpdate>
          {({ getFieldsError }) => {
            const errorList = getFieldsError();
            let showError = false;
            errorList.forEach((errors) => {
              if (errors.errors.length) {
                showError = true;
              }
            });
            return (
              showError && (
                <Text type="danger" style={{ marginTop: 16 }}>
                  Please correct the errors above
                </Text>
              )
            );
          }}
        </Form.Item>
        <Form.Item>
          <Button icon={<SendOutlined />} loading={loading} htmlType="submit">
            Send
          </Button>
        </Form.Item>
      </Form>
      {error && (
        <div className="errors">
          <Text type="danger">{error}</Text>
        </div>
      )}
    </Card>
  );
}

export default SendEnableTurboModeCommand;
